/**
 * Eagle Reborn PREMIUM Shopify Theme
 * Version: 2.0 - Full Feature Beast Mode!
 */

(function() {
  'use strict';

  // Security: HTML escape helper to prevent XSS
  function escapeHtml(text) {
    if (text == null) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Security: Sanitize URL to prevent javascript: protocol attacks
  function sanitizeUrl(url) {
    if (!url) return '';
    const trimmed = String(url).trim().toLowerCase();
    if (trimmed.startsWith('javascript:') || trimmed.startsWith('data:')) return '';
    return url;
  }

  const CONFIG = {
    recentlyViewedLimit: 8,
    lowStockThreshold: 5,
    promoPopupDelay: 5000,
    exitIntentEnabled: true
  };

  // ===== CART MANAGEMENT WITH SLIDE-OUT DRAWER =====
  const Cart = {
    updateCount: function() {
      fetch('/cart.js')
        .then(r => {
          if (!r.ok) throw new Error('Failed to fetch cart');
          return r.json();
        })
        .then(cart => {
          document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
        })
        .catch(err => {
          // Silently fail - cart count will update on next successful request
        });
    },

    addItem: function(variantId, quantity = 1) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] })
      })
      .then(r => {
        if (!r.ok) throw new Error('Failed to add item to cart');
        return r.json();
      })
      .then(data => {
        this.updateCount();
        this.openDrawer();
        return data;
      })
      .catch(err => {
        alert('Unable to add item to cart. Please try again.');
        throw err;
      });
    },

    openDrawer: function() {
      const drawer = document.getElementById('cartDrawer');
      if (drawer) {
        drawer.classList.add('active');
        document.body.style.overflow = 'hidden';
        this.loadItems();
      }
    },

    closeDrawer: function() {
      const drawer = document.getElementById('cartDrawer');
      if (drawer) {
        drawer.classList.remove('active');
        document.body.style.overflow = '';
      }
    },

    loadItems: function() {
      fetch('/cart.js')
        .then(r => {
          if (!r.ok) throw new Error('Failed to load cart');
          return r.json();
        })
        .then(cart => {
          const container = document.getElementById('cartDrawerItems');
          const total = document.getElementById('cartDrawerTotal');
          if (!container) return;

          if (cart.item_count === 0) {
            container.innerHTML = '<p style="text-align:center;padding:2rem;color:var(--text-medium)">Your cart is empty</p>';
            if (total) total.textContent = '$0.00';
            return;
          }

          container.innerHTML = cart.items.map((item, i) => `
            <div class="cart-drawer-item">
              <img src="${sanitizeUrl(item.image)}" alt="${escapeHtml(item.title)}">
              <div class="cart-item-details">
                <h4>${escapeHtml(item.product_title)}</h4>
                <p>${escapeHtml(item.variant_title || '')}</p>
                <p class="cart-item-price">$${(item.final_price/100).toFixed(2)}</p>
              </div>
              <div class="cart-item-actions">
                <input type="number" value="${parseInt(item.quantity) || 1}" min="1" data-line="${i+1}">
                <button data-remove="${i+1}">×</button>
              </div>
            </div>
          `).join('');

          // Event delegation for cart actions (safer than inline handlers)
          container.querySelectorAll('input[data-line]').forEach(input => {
            input.addEventListener('change', function() {
              Cart.updateQty(parseInt(this.dataset.line), this.value);
            });
          });
          container.querySelectorAll('button[data-remove]').forEach(btn => {
            btn.addEventListener('click', function() {
              Cart.removeItem(parseInt(this.dataset.remove));
            });
          });

          if (total) total.textContent = `$${(cart.total_price/100).toFixed(2)}`;
        })
        .catch(err => {
          const container = document.getElementById('cartDrawerItems');
          if (container) {
            container.innerHTML = '<p style="text-align:center;padding:2rem;color:var(--error-red)">Unable to load cart. Please refresh the page.</p>';
          }
        });
    },

    updateQty: function(line, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: parseInt(qty) })
      })
      .then(r => {
        if (!r.ok) throw new Error('Failed to update cart');
        return r.json();
      })
      .then(() => { this.loadItems(); this.updateCount(); })
      .catch(err => {
        alert('Unable to update cart. Please try again.');
      });
    },

    removeItem: function(line) { this.updateQty(line, 0); }
  };

  // ===== COUNTDOWN TIMER =====
  const CountdownTimer = {
    init: function() {
      document.querySelectorAll('[data-countdown]').forEach(timer => {
        const endDate = new Date(timer.dataset.countdown).getTime();
        this.start(timer, endDate);
      });
    },

    start: function(el, end) {
      const update = () => {
        const now = Date.now();
        const dist = end - now;

        if (dist < 0) {
          el.innerHTML = '<span class="expired">Deal Ended!</span>';
          return;
        }

        const d = Math.floor(dist / (1000*60*60*24));
        const h = Math.floor((dist % (1000*60*60*24)) / (1000*60*60));
        const m = Math.floor((dist % (1000*60*60)) / (1000*60));
        const s = Math.floor((dist % (1000*60)) / 1000);

        el.innerHTML = `
          <div class="countdown-segment"><span class="countdown-value">${d}</span><span class="countdown-label">Days</span></div>
          <div class="countdown-segment"><span class="countdown-value">${h.toString().padStart(2,'0')}</span><span class="countdown-label">Hrs</span></div>
          <div class="countdown-segment"><span class="countdown-value">${m.toString().padStart(2,'0')}</span><span class="countdown-label">Min</span></div>
          <div class="countdown-segment"><span class="countdown-value">${s.toString().padStart(2,'0')}</span><span class="countdown-label">Sec</span></div>
        `;
      };
      update();
      setInterval(update, 1000);
    }
  };

  // ===== STOCK COUNTER =====
  const StockCounter = {
    init: function() {
      document.querySelectorAll('[data-stock-count]').forEach(c => {
        const stock = parseInt(c.dataset.stockCount);
        if (stock <= CONFIG.lowStockThreshold && stock > 0) {
          c.innerHTML = `<div class="stock-warning">⚠️ Only ${stock} left!</div>`;
          c.style.color = 'var(--warning-amber)';
        }
      });
    }
  };

  // ===== RECENTLY VIEWED =====
  const RecentlyViewed = {
    init: function() {
      if (document.body.classList.contains('template-product')) this.save();
      this.display();
    },

    save: function() {
      const data = {
        id: location.pathname,
        title: document.querySelector('h1')?.textContent || '',
        image: document.querySelector('.product-image-wrapper img')?.src || '',
        price: document.querySelector('.price-current')?.textContent || '',
        url: location.pathname
      };
      let viewed = [];
      try {
        viewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
        if (!Array.isArray(viewed)) viewed = [];
      } catch (e) { viewed = []; }
      viewed = viewed.filter(p => p.id !== data.id);
      viewed.unshift(data);
      localStorage.setItem('recentlyViewed', JSON.stringify(viewed.slice(0, CONFIG.recentlyViewedLimit)));
    },

    display: function() {
      const container = document.getElementById('recentlyViewedProducts');
      if (!container) return;

      let viewed = [];
      try {
        viewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
        if (!Array.isArray(viewed)) viewed = [];
      } catch (e) { viewed = []; }
      const filtered = viewed.filter(p => p.id !== location.pathname).slice(0, 4);

      if (!filtered.length) { container.style.display = 'none'; return; }

      container.innerHTML = `
        <h3 style="font-size:var(--font-size-2xl);font-weight:600;margin-bottom:2rem;text-align:center">Recently Viewed</h3>
        <div class="product-grid">
          ${filtered.map(p => `
            <div class="product-card">
              <a href="${sanitizeUrl(p.url)}" class="product-image-wrapper"><img src="${sanitizeUrl(p.image)}" alt="${escapeHtml(p.title)}"></a>
              <div class="product-info">
                <a href="${sanitizeUrl(p.url)}" class="product-title">${escapeHtml(p.title)}</a>
                <div class="product-price"><span class="price-current">${escapeHtml(p.price)}</span></div>
                <a href="${sanitizeUrl(p.url)}" class="btn btn-primary btn-full">View Details</a>
              </div>
            </div>
          `).join('')}
        </div>
      `;
    }
  };

  // ===== PROMO POPUP =====
  const PromoPopup = {
    init: function() {
      if (this.hasBeenShown()) return;
      setTimeout(() => this.show(), CONFIG.promoPopupDelay);
      if (CONFIG.exitIntentEnabled) {
        document.addEventListener('mouseout', e => { if (e.clientY < 0) this.show(); }, { once: true });
      }
    },

    hasBeenShown: function() {
      const data = localStorage.getItem('promoShown');
      if (!data) return false;

      const timestamp = parseInt(data);
      const daysSince = (Date.now() - timestamp) / (1000 * 60 * 60 * 24);

      // Show again after 7 days
      if (daysSince > 7) {
        localStorage.removeItem('promoShown');
        return false;
      }

      return true;
    },

    show: function() {
      const popup = document.getElementById('promoPopup');
      if (!popup || this.hasBeenShown()) return;
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      localStorage.setItem('promoShown', Date.now().toString());
    },

    close: function() {
      const popup = document.getElementById('promoPopup');
      if (popup) { popup.style.display = 'none'; document.body.style.overflow = ''; }
    }
  };

  // ===== QUICK VIEW =====
  const QuickView = {
    init: function() {
      document.addEventListener('click', e => {
        if (e.target.closest('.quick-view-btn')) {
          e.preventDefault();
          this.open(e.target.closest('.quick-view-btn').dataset.productUrl);
        }
      });
    },

    open: function(url) {
      const modal = document.getElementById('quickViewModal');
      if (!modal) return;

      // Security: Validate URL is same-origin and a valid product path
      try {
        const parsedUrl = new URL(url, window.location.origin);
        if (parsedUrl.origin !== window.location.origin) {
          console.error('Quick view blocked: external URL');
          return;
        }
        if (!parsedUrl.pathname.startsWith('/products/')) {
          console.error('Quick view blocked: invalid path');
          return;
        }
      } catch (e) {
        console.error('Quick view blocked: invalid URL');
        return;
      }

      fetch(url + '?view=quick')
        .then(r => {
          if (!r.ok) throw new Error('Failed to load quick view');
          return r.text();
        })
        .then(html => {
          document.getElementById('quickViewContent').innerHTML = html;
          modal.style.display = 'flex';
          document.body.style.overflow = 'hidden';
        })
        .catch(err => {
          console.error('Quick view error:', err);
        });
    },

    close: function() {
      const modal = document.getElementById('quickViewModal');
      if (modal) { modal.style.display = 'none'; document.body.style.overflow = ''; }
    }
  };

  // ===== IMAGE ZOOM =====
  const ImageZoom = {
    init: function() {
      document.querySelectorAll('.zoomable-image').forEach(img => {
        img.addEventListener('mouseenter', () => this.create(img));
        img.addEventListener('mouseleave', () => this.remove());
        img.addEventListener('mousemove', e => this.move(e, img));
      });
    },

    create: function(img) {
      const zoom = document.createElement('div');
      zoom.className = 'image-zoom-lens';
      zoom.style.backgroundImage = `url(${img.src})`;
      img.parentElement.appendChild(zoom);
    },

    remove: function() {
      document.querySelector('.image-zoom-lens')?.remove();
    },

    move: function(e, img) {
      const lens = document.querySelector('.image-zoom-lens');
      if (!lens) return;
      const rect = img.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      lens.style.left = x + 'px';
      lens.style.top = y + 'px';
      lens.style.backgroundPosition = `-${x*2}px -${y*2}px`;
    }
  };

  // ===== LIGHTBOX =====
  const Lightbox = {
    current: 0,
    images: [],

    init: function() {
      document.addEventListener('click', e => {
        if (e.target.closest('.lightbox-trigger')) {
          e.preventDefault();
          const t = e.target.closest('.lightbox-trigger');
          try {
            this.images = JSON.parse(t.dataset.images || '[]');
            if (!Array.isArray(this.images)) this.images = [];
          } catch (err) { this.images = []; }
          this.current = parseInt(t.dataset.index || 0) || 0;
          this.open();
        }
      });
    },

    open: function() {
      const lb = document.getElementById('lightbox');
      if (!lb || !this.images.length) return;
      this.update();
      lb.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    },

    close: function() {
      const lb = document.getElementById('lightbox');
      if (lb) { lb.style.display = 'none'; document.body.style.overflow = ''; }
    },

    next: function() { this.current = (this.current + 1) % this.images.length; this.update(); },
    prev: function() { this.current = (this.current - 1 + this.images.length) % this.images.length; this.update(); },

    update: function() {
      const img = document.getElementById('lightboxImage');
      const counter = document.getElementById('lightboxCounter');
      if (img) img.src = this.images[this.current];
      if (counter) counter.textContent = `${this.current + 1} / ${this.images.length}`;
    }
  };

  // ===== BACK TO TOP =====
  const BackToTop = {
    init: function() {
      const btn = document.getElementById('backToTop');
      if (!btn) return;
      window.addEventListener('scroll', () => {
        btn.style.display = window.pageYOffset > 300 ? 'flex' : 'none';
      });
      btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    }
  };

  // ===== PROMO BANNER =====
  const PromoBanner = {
    init: function() {
      const banner = document.getElementById('promoBanner');
      if (!banner) return;
      banner.querySelector('.promo-close')?.addEventListener('click', () => {
        banner.style.display = 'none';
        sessionStorage.setItem('promoBannerClosed', 'true');
      });
      if (sessionStorage.getItem('promoBannerClosed')) banner.style.display = 'none';
    }
  };

  // ===== PRODUCT TABS =====
  const ProductTabs = {
    init: function() {
      document.querySelectorAll('.product-tab').forEach(tab => {
        tab.addEventListener('click', () => {
          document.querySelectorAll('.product-tab').forEach(t => t.classList.remove('active'));
          document.querySelectorAll('.product-tab-content').forEach(c => c.classList.remove('active'));
          tab.classList.add('active');
          document.getElementById(tab.dataset.tab)?.classList.add('active');
        });
      });
    }
  };

  // ===== MOBILE MENU =====
  const MobileMenu = {
    init: function() {
      const toggle = document.getElementById('mobileMenuToggle');
      const menu = document.getElementById('mobileMenu');
      if (toggle && menu) {
        toggle.addEventListener('click', e => {
          e.stopPropagation();
          menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
        });
        document.addEventListener('click', e => {
          if (!menu.contains(e.target) && !toggle.contains(e.target)) menu.style.display = 'none';
        });
      }
    }
  };

  // ===== SEARCH OVERLAY =====
  const SearchOverlay = {
    init: function() {
      const toggle = document.getElementById('searchToggle');
      const overlay = document.getElementById('searchOverlay');
      const close = document.getElementById('searchClose');
      if (toggle && overlay) {
        toggle.addEventListener('click', () => {
          overlay.style.display = 'flex';
          setTimeout(() => document.querySelector('.search-input')?.focus(), 100);
          document.body.style.overflow = 'hidden';
        });
        close?.addEventListener('click', () => { overlay.style.display = 'none'; document.body.style.overflow = ''; });
        document.addEventListener('keydown', e => {
          if (e.key === 'Escape') { overlay.style.display = 'none'; document.body.style.overflow = ''; }
        });
      }
    }
  };

  // ===== INIT ALL =====
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    Cart.updateCount();
    CountdownTimer.init();
    StockCounter.init();
    RecentlyViewed.init();
    PromoPopup.init();
    QuickView.init();
    ImageZoom.init();
    Lightbox.init();
    BackToTop.init();
    PromoBanner.init();
    ProductTabs.init();
    MobileMenu.init();
    SearchOverlay.init();

    // Eagle Reborn PREMIUM Theme Initialized
  }

  init();

  window.EagleReborn = { Cart, CountdownTimer, PromoPopup, QuickView, Lightbox };

})();

// ===== SMOOTH SCROLL EFFECTS =====
const SmoothScroll = {
  init: function() {
    // Fade in elements on scroll
    this.observeElements();
    
    // Smooth anchor links
    this.smoothAnchors();
    
    // Parallax effect for hero
    this.parallaxHero();
  },

  observeElements: function() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1
    });

    // Observe all sections
    document.querySelectorAll('.category-card, .product-card, .promo-card').forEach(el => {
      el.classList.add('fade-in-on-scroll');
      observer.observe(el);
    });
  },

  smoothAnchors: function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href !== '#' && href !== '') {
          const target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    });
  },

  parallaxHero: function() {
    const hero = document.querySelector('.hero-section');
    if (!hero) return;

    window.addEventListener('scroll', () => {
      const scrolled = window.pageYOffset;
      if (scrolled < window.innerHeight) {
        hero.style.transform = `translateY(${scrolled * 0.5}px)`;
        hero.style.opacity = 1 - (scrolled / window.innerHeight) * 0.5;
      }
    }, { passive: true });
  }
};

// Initialize on load
if (typeof window.EagleReborn !== 'undefined') {
  const originalInit = window.addEventListener('load', () => {
    SmoothScroll.init();
  });
}

